export const SET_FOCUSED = "SET_FOCUSED";
export const SET_ADJUNTOS = "SET_ADJUNTOS";
export const SET_SINGLE_ADJUNTO = "SET_SINGLE_ADJUNTO";
export const SET_PROPERTY_ADJUNTO = "SET_PROPERTY_ADJUNTO";
